import { render, staticRenderFns } from "./FifthStep.vue?vue&type=template&id=604331b8&scoped=true"
import script from "./FifthStep.vue?vue&type=script&lang=js"
export * from "./FifthStep.vue?vue&type=script&lang=js"
import style0 from "./FifthStep.vue?vue&type=style&index=0&id=604331b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604331b8",
  null
  
)

export default component.exports